

















import Vue from "vue";

export default Vue.extend({
  name: "SafeClosePopup",
  computed: {
    showSuccessContent(): boolean {
      const successParam = Array.isArray(this.$route.query.success)
        ? this.$route.query.success[0]
        : this.$route.query.success;
      if (successParam?.toLowerCase() === "false") {
        return false;
      }
      return String(successParam).toLowerCase() !== "false";
    },
    errorCode(): string {
      const rawErrorCode =
        (Array.isArray(this.$route.query.errorCode)
          ? this.$route.query.errorCode[0]
          : this.$route.query.errorCode) ??
        (Array.isArray(this.$route.query.errorcode)
          ? this.$route.query.errorcode[0]
          : this.$route.query.errorcode);

      const code = String(rawErrorCode || "")
        .trim()
        .toUpperCase();
      const errorMessages: Record<string, string> = {
        EA404: "EA404 - Session expired.",
        EA405:
          "EA405 - The user is trying to connect with a different account.",
        EA407:
          "EA407 - The user is trying to connect with a different account.",
        TS401:
          "TS401 - User does not have a valid Teams license. Microsoft room resource accounts without Teams Rooms Pro or Teams Rooms Basic license.",
        MS401:
          "MS401 - The app is trying to access a service that your organization lacks a service principal for.",
        MS402:
          "MS402 - The service principal for the resource is disabled. This indicates that a subscription within the tenant has lapsed, or that the administrator for this tenant has disabled the application, preventing tokens from being issued.",
        MS403:
          "MS403 - The user or administrator has not consented to use the application.",
      };

      return errorMessages[code] || "Unknown error";
    },
  },
  methods: {
    handleClose(): void {
      window.close();
    },
  },
});
